import { StatusBadge, type Tom } from "@/components/data/status-badge";
import {
  ROTULO_DINHEIRO_VENDA,
  rotuloDivergencia,
  type DivergenciaDTO,
  type EstadoDinheiroVenda,
} from "@shared/mercado";

/**
 * O DINHEIRO da venda — o chip da coluna Status de Vendas (Cacho) e da coluna
 * Pagamento de A receber (Mercado). O estado sai de `estadoDinheiroDaVenda`
 * (shared), calculado UMA vez; aqui só vira cor.
 *
 * ⚠️ Não existe "Informado · confirme": quem registra quita (#246). CONTESTADO é
 * o "Não recebi" do produtor, esperando o comprador registrar de novo — vermelho
 * porque é a única linha que pede conversa.
 */
export const TOM_DINHEIRO: Record<EstadoDinheiroVenda, Tom> = {
  RASCUNHO: "info",
  A_RECEBER: "atencao",
  PARCIAL: "atencao",
  CONTESTADO: "erro",
  PAGA: "sucesso",
  CANCELADA: "erro",
};

export function ChipDinheiro({ estado, testIdSufixo }: { estado: EstadoDinheiroVenda; testIdSufixo?: string }) {
  return (
    <StatusBadge tom={TOM_DINHEIRO[estado]} ponto testId={`chip-dinheiro-${estado}${testIdSufixo ? `-${testIdSufixo}` : ""}`}>
      <span className={estado === "CANCELADA" ? "line-through" : undefined}>{ROTULO_DINHEIRO_VENDA[estado]}</span>
    </StatusBadge>
  );
}

/**
 * "Divergência · −120 kg" — só quando a conferência VÁLIDA do comprador não bate
 * com o emitido. Conferido e igual não vira chip (fica no histórico). É um botão:
 * abre a venda na seção da conferência, onde os dois números ficam lado a lado.
 */
export function ChipDivergencia({
  divergencia, onAbrir, testIdSufixo,
}: {
  divergencia: DivergenciaDTO;
  onAbrir: () => void;
  testIdSufixo?: string;
}) {
  return (
    <button
      type="button"
      className="inline-flex rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      onClick={e => { e.stopPropagation(); onAbrir(); }}
      title="Ver a conferência do comprador"
      data-testid={`chip-divergencia${testIdSufixo ? `-${testIdSufixo}` : ""}`}
    >
      <StatusBadge tom="erro" ponto>{rotuloDivergencia(divergencia)}</StatusBadge>
    </button>
  );
}
